import PropTypes from "prop-types";

const BtnSecondaryM = ({
  buttonCTA,
  onClickLink,
  type,
  disabled,
  className,
}) => {
  // If onClickLink is a function, it's for internal navigation
  if (typeof onClickLink === "function") {
    return (
      <button
        className={`btn-secondary-m text-base md:text-sm ${className || ""}`}
        onClick={onClickLink}
        type={type}
        disabled={disabled}
      >
        {buttonCTA}
      </button>
    );
  }

  // If onClickLink is a string, it's an external link
  if (typeof onClickLink === "string") {
    return (
      <a
        href={onClickLink}
        target="_blank"
        rel="noopener noreferrer"
        className={`btn-secondary-m inline-block text-base md:text-sm ${className || ""}`}
      >
        {buttonCTA}
      </a>
    );
  }

  // Default button without link
  return (
    <button
      className={`btn-secondary-m text-base md:text-sm ${className || ""}`}
      type={type}
      disabled={disabled}
    >
      {buttonCTA}
    </button>
  );
};

BtnSecondaryM.propTypes = {
  buttonCTA: PropTypes.string.isRequired,
  onClickLink: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  type: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default BtnSecondaryM;
